import styled from 'styled-components'
import { tokens, Card, Dropdown, Table } from '@arvoreeducacao/bonsai-ds'

export const Wrapper = styled.div`
  margin: ${tokens.spacing.squishLarge};

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    margin: ${tokens.spacing.squishXxxlarge};
  }
`

export const TopBar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    flex-direction: row;
    align-items: center;
  }
`

export const EntitiesTopBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: ${tokens.spacing.verticalXxlarge};

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    margin-top: 0;
  }
`

export const SearchWrapper = styled.div`
  width: 100%;
  position: relative;
  margin-top: ${tokens.spacing.verticalMedium};

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    max-width: 254px;
    margin-top: 0;
  }
`

export const BreadCrumbWrapper = styled.div`
  margin-top: ${tokens.spacing.verticalXxlarge};
  display: none;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    display: block;
  }
`

export const Hr = styled.hr`
  border-top: 1px solid ${tokens.colors.dark2};
  border-radius: 2px;
  display: none;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    display: block;
  }
`

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: ${tokens.spacing.verticalLarge} -${tokens.spacing.horizontalXsmall} 0 -${tokens
      .spacing.horizontalXsmall};
`

export const StyledCard = styled(Card)`
  width: 100%;
`

export const CardWrapper = styled.div`
  margin-bottom: ${tokens.spacing.verticalMedium};
  width: 100%;
  padding: 0 ${tokens.spacing.horizontalXsmall};

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    width: calc(100% / 3);
  }
`

export const UserTableTopBarActionsWrapper = styled.div`
  display: flex;
  margin-top: ${tokens.spacing.verticalLarge};

  > button {
    margin-right: ${tokens.spacing.horizontalMedium};
  }

  > button:last-child {
    margin-right: 0;
  }

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    margin-top: 0;
  }
`

export const TitleLabel = styled.span`
  color: ${tokens.colors.dark4};
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.regular};
`

export const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`

export const StyledDropdown = styled(Dropdown)`
  position: absolute;
  top: 100%;
  bottom: initial;
`

export const StudentName = styled.span`
  color: ${tokens.colors.dark6};
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.regular};
  margin-right: ${tokens.spacing.horizontalMedium};
`

export const StyledTable = styled(Table)`
  overflow-x: visible;
`
export const Title = styled.h1`
  margin: 0;
  color: ${tokens.colors.dark6};
  font-size: ${tokens.sizes.h[3].default};
  font-weight: ${tokens.fontWeights.bold};
  line-height: ${tokens.lineHeight.medium}%;
`

export const TitleHeader = styled.h1`
  margin: 0;
  color: ${tokens.colors.dark6};
  font-size: ${tokens.sizes.h[2].tablet};
  font-weight: ${tokens.fontWeights.bold};
  line-height: ${tokens.lineHeight.medium}%;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    font-size: ${tokens.sizes.h[2].default};
  }
`

export const TitleActives = styled.h1`
  margin: 0;
  color: ${tokens.colors.dark6};
  font-size: ${tokens.sizes.h[5].default};
  font-weight: ${tokens.fontWeights.bold};
  line-height: ${tokens.lineHeight.medium}%;
`

export const ListItemContainer = styled.div`
  border-top: 1px solid ${tokens.colors.dark1};
`

export const ModalMoreOptionsHeader = styled.div`
  display: flex;
  gap: ${tokens.spacing.horizontalXsmall};
  padding: ${tokens.spacing.insetMedium};
  align-items: center;
`

export const NameColumnMobileViewWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`
